export const LOADING_PERMISSIONS = "LOADING_PERMISSIONS";
export const GET_PERMISSIONS_LIST = "GET_PERMISSIONS_LIST";
